const translationUK = {
  generalData: 'Загальні дані',
  name: 'Повне імʼя',
  nameParam: 'Імʼя',
  date: 'Дата',
  phoneNumber: 'Телефон',
  patientGeneralData: 'Загальні дані пацієнта',
  detailData: 'Детальні дані',
  feetMeasurement: 'Вимірювання стоп',
  overview: 'Огляд',
  firstNameRequired: "Імʼя є обовʼязковим",
  firstName: "Імʼя",
  lastName: 'Прізвище',
  identityId: 'ID',
  emailLabel: 'E-mail',
  phoneNumber1: 'Номер телефону 1',
  phoneNumber2: 'Номер телефону 2',
  gender: 'Стать',
  selectGender: 'Будь ласка, виберіть стать',
  male: 'Чоловіча',
  female: 'Жіноча',
  dateofBirth: 'Дата народження',
  birthDateRequired: 'Дата народження є обовʼязковою',
  height: 'Зріст',
  weight: 'Вага',
  shoeSize: 'Розмір взуття',
  euShoeSize: 'Розмір взуття (EU)',
  rightHanded: 'Правша',
  leftHanded: 'Лівша',
  controlExamSchedule: 'Графік контрольного огляду',
  ekovelReport: 'Звіт Ekovel',
  generalExamination: 'Загальне обстеження',
  optimalWeight: 'Оптимальна вага',
  feetParametes: 'Параметри стоп',
  role: 'Роль',
  displayName: 'Відображуване імʼя',
  userName: 'Імʼя користувача',
  organization: 'Організація',
  active: 'Активний',
  deleteConfirmation: 'Підтвердження видалення',
  areYouSureToDelete: 'Ви впевнені, що хочете видалити користувача',
  delete: 'Видалити',
  cancel: 'Скасувати',
  deactivate: 'Деактивувати',
  activate: 'Активувати',
  activateUser: 'Активувати користувача',
  deactivateConfirmation: 'Підтвердження деактивації',
  areYouSureDeactivate: 'Ви впевнені, що хочете деактивувати користувача',
  areYouSureActivate: 'Ви впевнені, що хочете активувати користувача',
  updateSerialNumber: 'Оновити серійний номер',
  areYouSureToDeleteUser: 'Ви впевнені, що хочете видалити користувача',
  actions: 'Дії',
  parameter: 'Параметр',
  value: 'Значення',
  ekovelStepCorrectsize: 'Етап Ekovel: правильний розмір',
  initialHeight: 'Початковий зріст',
  optimalHeight: 'Оптимальний зріст',
  firstCheck: 'Перша перевірка',
  secondCheck: 'Друга перевірка',
  thirdCheck: 'Третя перевірка',
  therapy: 'Терапія',
  leftFoot: 'Ліва стопа',
  rightFoot: 'Права стопа',
  serialNumber: 'Серійний номер',
  footLength: 'Довжина стопи (мм)',
  footWidth: 'Ширина стопи (мм)',
  left: 'Ліва',
  right: 'Права',
  back: 'Назад',
  finish: 'Завершити',
  next: 'Далі',
  selectLeg: 'Вибрати ногу',
  legLengthDifference: 'Різниця довжини ніг',
  adjustmentInterval: 'Інтервал корекції',
  adjustmentPeriod: 'Період корекції AI',
  week: 'Тиждень',
  weeks: 'Тижні',
  serialNumberDate: 'Дата серійного номера',
  checkExaminationSchedule: 'Перевірити графік огляду',
  escSize: 'Розмір ESC',
  saveAndOpenReport: 'Зберегти та відкрити звіт',
  create: 'Створити',
  noRowsToShowPatients: 'Немає даних',
  DepthOfFootArch: 'Глибина склепіння стопи',
  DegreeOfTendon: 'Положення сухожилля',
  LegLengthDifference: 'Різниця довжини ніг',
  FootprintSplit: 'Розподіл відбитка стопи',
  FootParamDescription: 'Опис параметрів стопи',
  report: 'Звіт',
  examinationDate: 'Дата обстеження',
  leftFootMeasurement: 'Вимірювання лівої стопи',
  rightFootMeasurement: 'Вимірювання правої стопи',
  footParametersLeft: 'Параметри лівої стопи',
  footParametersRight: 'Параметри правої стопи',
  optimalMlaDepth: 'Оптимальна глибина MLA',
  optimalMlaHeight: 'Оптимальна висота MLA',
  mlaDescendingLevel: 'Рівень зниження MLA',
  mlaDescending: 'Зниження MLA',
  tendonPosition: 'Положення сухожилля',
  legAlignement: 'Вирівнювання ніг',
  and: 'І',
  selectedLeg: 'Обрана нога',
  allAdmins: 'УСІ АДМІНІСТРАТОРИ',
  allUsers: 'УСІ КОРИСТУВАЧІ',
  allPatients: 'УСІ ПАЦІЄНТИ',
  therapyDuration: 'Тривалість терапії',
  medialArchDisplacement: 'Зміщення медіального склепіння',
  verticalDisplacement: 'Вертикальне зміщення',
  horizontalDisplacement: 'Горизонтальне зміщення',
  displacementPoourcentage: 'Відсоток зміщення',
  displacementLevel: 'Рівень зміщення',
  medialArchDepth: 'Глибина медіального склепіння X [мм]',
  medialArchHeight: 'Висота медіального склепіння Y [мм]',
  tendonBendingDegree: 'Ступінь згинання сухожилля',
  medialArchOptimalDepth: 'Оптимальна глибина медіального склепіння Xo [мм]',
  medialArchOptimalHeight: 'Оптимальна висота медіального склепіння Yo [мм]',
  backToPatientsList: 'Повернутися до форми',
  allStepsAreDone: 'Усі кроки завершено',
  user: 'Користувач',
  yes: 'Так',
  no: 'Ні',
  selectAlignment: 'Вибрати вирівнювання',
  createAdmin: 'Створити адміністратора',
  createUser: 'Створити користувача',
  createPatient: 'Створити пацієнта',
  editPatient: 'Редагувати пацієнта',
  serialNumberSucces: 'Серійний номер успішно оновлено',
  noRowsToShow: 'Немає результатів для відображення',
  admittedBy: 'Прийнято',
  logout: 'Вийти',
  search: 'Пошук',
  suborganization: 'Підорганізація',
  town: 'Місто',
  userSuccess: 'Успішно створено',
  emailAlreadyExist: 'Помилка: Email уже існує',
  loginErroMEssage: 'Неправильне імʼя користувача або пароль.',
  accept: 'Погоджуюсь',

  privacyPolicy: 'Політика конфіденційності',
  lastUpdated: 'Останнє оновлення: 03.04.2025',
  privacyPolicyIntro:
    'Ласкаво просимо до додатку компанії Ekovel. Ми прагнемо захищати вашу конфіденційність та безпеку персональних даних. Ця Політика конфіденційності пояснює, які дані ми збираємо, як їх використовуємо та зберігаємо.',
  dataCollectionTitle: '1. ЗБІР ДАНИХ',
  personalData:
    'Персональні дані пацієнтів: імʼя, прізвище, дата народження, контактна інформація.',
  therapyData:
    'Дані терапії: медичні висновки, рекомендовані процедури, дані про ортопедичні устілки.',
  technicalData:
    'Технічні дані: інформація про пристрій, IP-адреса, дані використання додатку.',
  dataUsageTitle: '2. ВИКОРИСТАННЯ ДАНИХ',
  dataUsage1: 'Ведення обліку пацієнтів та їх терапій.',
  dataUsage2: 'Створення та індивідуальне налаштування ортопедичних устілок.',
  dataUsage3: 'Покращення якості сервісу та функціональності додатку.',
  dataUsage4: 'Виконання юридичних та регуляторних зобовʼязань.',
  dataStorageTitle: '3. ЗБЕРІГАННЯ ТА ЗАХИСТ ДАНИХ',
  dataProtection:
    'Ваші дані зберігаються на захищених серверах з обмеженим доступом та захищені відповідними заходами безпеки. Доступ до даних мають лише уповноважені особи.',
  userRightsTitle: '4. ПРАВА КОРИСТУВАЧА',
  userRights1: 'Доступ до своїх даних.',
  userRights2: 'Запит на виправлення неточних даних.',
  userRights3: 'Запит на видалення даних, коли вони більше не потрібні.',
  userRights4: 'Відкликання згоди на обробку даних.',
  contactRights:
    'Для реалізації своїх прав звʼяжіться з нами за адресою ekovelcentar@gmail.com',
  privacyPolicyAcceptanceTitle: '5. ПРИЙНЯТТЯ ПОЛІТИКИ КОНФІДЕНЦІЙНОСТІ',
  privacyPolicyAcceptance:
    'Користуючись цим додатком, користувачі підтверджують, що прочитали, зрозуміли та погоджуються з Політикою конфіденційності.',
  contactTitle: '6. КОНТАКТ',
  contactIntro:
    'Якщо у вас є запитання щодо цієї Політики конфіденційності, ви можете звернутися до нас:',
  companyName: 'EKOVEL CENTAR DOO',
  companyAddress: 'Ugrinovački put 104, 11080, Белград (Земун), Сербія',
  companyEmail: 'Email: ekovelcentar@gmail.com',
  companyPhone: 'Телефон: 0113774750',
  policyUpdateNotice:
    'Ми залишаємо за собою право періодично оновлювати цю Політику конфіденційності. Про всі зміни ви будете своєчасно повідомлені через додаток.',
};

export { translationUK };
